(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-campaign-spotlight"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sk-campaign-spotlight')) {
  customElements.define('sk-campaign-spotlight', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.interval);
      this.end = Date.parse(this.dataset.end);
      this.start = Date.parse(this.dataset.start);
      this.tick = () => {
        const now = Date.now();
        if (!Number.isFinite(this.end) || !Number.isFinite(this.start) || now >= this.end || now < this.start) {
          this.hidden = true;
          const section = this.closest('.shopify-section');
          if (section) section.hidden = true;
          clearInterval(this.interval);
          return;
        }
        const seconds = Math.ceil((this.end - now) / 1000);
        const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds % 86400 / 3600), minutes: Math.floor(seconds % 3600 / 60), seconds: seconds % 60 };
        Object.entries(values).forEach(([key, value]) => {
          const output = this.querySelector('[data-' + key + ']');
          if (output) output.textContent = key === 'days' ? String(value) : String(value).padStart(2, '0');
        });
      };
      this.interval = setInterval(this.tick, 1000);
      this.tick();
      document.addEventListener('visibilitychange', this.tick);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.tick);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-sk-cookie-settings]');
    if (!button) return;
    const status = button.parentElement.querySelector('[data-sk-cookie-status]');
    try {
      if (typeof privacyBanner === 'undefined' || typeof privacyBanner.showPreferences !== 'function') throw new Error('Privacy preferences unavailable');
      await privacyBanner.showPreferences();
      if (status) status.hidden = true;
    } catch {
      if (status) status.hidden = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-spare-part"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeSpareParts(scope) {
      var sections = scope.querySelectorAll('[data-spare-part]');
      for (var i = 0; i < sections.length; i += 1) {
        var section = sections[i];
        if (section.dataset.sparePartReady) continue;
        section.dataset.sparePartReady = 'true';
        (function (part) {
          var selector = part.querySelector('[data-part-variant]');
          var quantity = part.querySelector('[data-part-quantity]');
          var button = part.querySelector('[data-part-add]');
          if (!selector || !quantity || !button) return;

          function updateVariant() {
            var option = selector.options[selector.selectedIndex];
            if (!option) return;
            var available = option.dataset.available === 'true';
            var requiresPlan = option.dataset.requiresPlan === 'true';
            var price = part.querySelector('[data-part-price]');
            var compare = part.querySelector('[data-part-compare]');
            var sku = part.querySelector('[data-part-sku]');
            var maximum = part.querySelector('[data-part-max]');
            var min = Number(option.dataset.min) || 1;
            var step = Number(option.dataset.step) || 1;
            var max = Number(option.dataset.max) || 0;
            var value = Math.max(Number(quantity.value) || min, min);
            value = min + Math.ceil((value - min) / step) * step;
            if (max && value > max) value = min + Math.floor((max - min) / step) * step;

            price.textContent = option.dataset.price;
            compare.textContent = option.dataset.compare;
            compare.hidden = !option.dataset.compare;
            sku.querySelector('span').textContent = option.dataset.sku;
            sku.hidden = !option.dataset.sku;
            quantity.min = String(min);
            quantity.step = String(step);
            if (max) quantity.max = String(max);
            else quantity.removeAttribute('max');
            quantity.value = String(value);
            part.querySelector('[data-part-min]').textContent = String(min);
            part.querySelector('[data-part-step]').textContent = String(step);
            maximum.querySelector('span').textContent = option.dataset.max;
            maximum.hidden = !max;
            part.querySelector('[data-part-quantity-rule]').hidden = min === 1 && step === 1 && !max;
            part.querySelector('[data-part-availability]').textContent = available ? 'Tilattavissa' : 'Loppuunmyyty';
            part.querySelector('[data-part-plan-note]').hidden = !requiresPlan;
            button.disabled = !available || requiresPlan;
            button.textContent = available ? 'Lisää koriin' : 'Loppuunmyyty';

            var url = new URL(window.location.href);
            url.searchParams.set('variant', option.value);
            window.history.replaceState({}, '', url.toString());
          }

          selector.addEventListener('change', updateVariant);
          part.querySelector('form').addEventListener('submit', function (event) {
            var option = selector.options[selector.selectedIndex];
            if (!option || option.dataset.available !== 'true' || option.dataset.requiresPlan === 'true') event.preventDefault();
          });
          updateVariant();
        })(section);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initializeSpareParts(document); });
    } else {
      initializeSpareParts(document);
    }
    document.addEventListener('shopify:section:load', function (event) { initializeSpareParts(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
